import * as React from 'react'

class Container extends React.Component<{ children?: React.ReactNode }> {
    public render = () => (
        <aside className="full skin-blue" {...this.props}>
            {this.props.children}
        </aside>
    )
}

class Row extends React.Component<{ children?: React.ReactNode; className?: string }> {
    public render = () => (
        <div className="row" {...this.props}>
            {this.props.children}
        </div>
    )
}

type GridSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12

interface ColProps {
    width?: GridSize
    widthSmall?: GridSize
    widthMedium?: GridSize
    widthLarge?: GridSize
    offsetSmall?: GridSize
    offsetMedium?: GridSize
    offsetLarge?: GridSize
    centered?: boolean
    className?: string
    children?: React.ReactNode
}

class Col extends React.Component<ColProps> {
    public render = () => {
        let props = {
            widthSmall: this.props.width || 12,
            widthMedium: this.props.width || 12,
            widthLarge: this.props.width || 12,
            offsetSmall: 0,
            offsetMedium: 0,
            offsetLarge: 0,
            centered: false,
            ...this.props,
        }

        if (props.centered) {
            props = {
                ...props,
                offsetSmall: this.center(props.widthSmall),
                offsetMedium: this.center(props.widthMedium),
                offsetLarge: this.center(props.widthLarge),
            }
        }

        const classes = [
            'col',
            'col-sm-' + props.widthSmall,
            'col-md-' + props.widthMedium,
            'col-lg-' + props.widthLarge,
            'col-sm-offset-' + props.offsetSmall,
            'col-md-offset-' + props.offsetMedium,
            'col-lg-offset-' + props.offsetLarge,
            this.props.className || '',
        ]

        return <div className={classes.join(' ')}>{props.children}</div>
    }

    private center = cols => Math.floor((12 - cols) / 2)
}

export { Container, Row, Col }
